export { marketingDesign } from '&/locales/zh-CN/pages/marketingDesign';
